export type MaskType = 'email' | 'phone';

/**
 * Masks an email address, preserving domain and showing only first/last user char.
 * Falls back to original if not a valid email.
 */
export function maskEmail(email: string): string {
  const [user, domain] = email.split('@');
  if (!user || !domain) {
    return email; // fallback if malformed
  }

  // Mask everything except the first and last character, unless username is <=2 chars
  if (user.length <= 2) {
    return user[0] + '*@' + domain;
  }

  return user[0] + '*'.repeat(user.length - 2) + user.slice(-1) + '@' + domain;
}

/**
 * Masks a phone number, preserving country code and last 3 digits.
 * Handles any country code (up to 4 digits).
 * Falls back to original if not valid.
 */
export function maskPhone(phone: string): string {
  return phone.replace(
    /(\+\d{2})(\d+)(\d{3})$/,
    (m, p1, p2, p3) => p1 + '*'.repeat(p2.length) + p3
  );
}

/**
 * Generic mask for email or phone.
 */
export function mask(value: string, type: MaskType): string {
  if (type === 'email') return maskEmail(value);
  if (type === 'phone') return maskPhone(value);
  return value;
}
